import React from 'react';
import copy from 'copy-to-clipboard';
import { useToast, Icon } from '@pairy/pds-react';

import { GOOGLE_EVENT_ID } from '../../../../../../constant/googleEventId';
import useFileHistoryShare from '../../../../../../hooks/mutation/file/useFileHistoryShare';
import { useViewerRoute } from '../../../../../../contexts/ViewerRoute';

import * as Styled from './index.styles';

export interface MobileShareButtonProps {
  fileName?: string;
  domain?: string | null;
  isBulk: boolean;
  translateKoToEn: (item: string) => string;
}

const MobileShareButton = ({
  fileName,
  domain,
  translateKoToEn,
  isBulk,
}: MobileShareButtonProps) => {
  const { historyId, getShareUrl } = useViewerRoute();
  const toast = useToast();

  const { mutate: mutateFileHistoryShare } = useFileHistoryShare(isBulk);

  const handleClickLinkCopyButton = (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.stopPropagation();
    const url = getShareUrl({ domain, isBulk });

    if (navigator.share) {
      try {
        navigator.share({
          title: fileName,
          url,
        });
      } catch {
        copyClipboard(url);
      }
    } else {
      copyClipboard(url);
    }

    mutateFileHistoryShare({ historyId });
  };

  const copyClipboard = (url: string) => {
    copy(url);

    toast(`${translateKoToEn('link-copy')}`);
  };

  return (
    <Styled.Button
      id={GOOGLE_EVENT_ID.share}
      variant="zinc_500"
      radius={9999}
      onClick={handleClickLinkCopyButton}
      leftIcon={<Icon icon="ph:share-network" size={19} color="black" />}
    ></Styled.Button>
  );
};

export default MobileShareButton;
